import React from "react"
import { css } from "@emotion/core"
import { Link } from "gatsby"

class PlaybookCategory extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div
        css={css`
          display: grid;
          grid-template-columns: 1fr;
          grid-template-rows: auto;
          grid-auto-rows: auto;

          margin-bottom: 120px;

          grid-gap: 1px;
          background-color: #aaa;

          box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.05);
          border: 1px solid #aaa;
          border-radius: 3px;
          overflow: hidden;

          > div {
            background-color: #fff;
            // min-height: 240px;
          }
        `}
      >
        {this.props.children}
      </div>
    )
  }
}

class PlaybookContext extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div
        css={css`
          padding: 40px 60px;
          background-color: #f8f8f8 !important;

          @media only screen and (max-width: 576px) {
            padding: 40px;
          }
        `}
      >
        <div
          css={css`
            font-size: 24px;
            font-weight: 600;
            color: #473dc7;
            margin-bottom: 8px;
          `}
        >
          {this.props.category}
        </div>
        <div
          css={css`
            p {
              margin-bottom: 0;
            }
          `}
        >
          {this.props.children}
        </div>
      </div>
    )
  }
}

class PlaybookProduct extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div
        css={css`
          padding: 40px 60px;
          @media only screen and (max-width: 576px) {
            padding: 40px;
          }
        `}
      >
        <div
          css={css`
            font-weight: 600;
            font-size: 18px;
            margin-bottom: 12px;
          `}
        >
          {this.props.recommendation}
        </div>
        <a
          href={this.props.href}
          css={css`
            font-weight: 600;
            font-size: 22px;
            color: #473dc7;
            margin-bottom: 18px;
            display: inline-block;

            :hover {
              color: #4e9aa8;
            }
          `}
        >
          {this.props.name}
        </a>

        <div>{this.props.children}</div>
      </div>
    )
  }
}

class PlaybookAlternatives extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div
        css={css`
          padding: 35px;
          @media only screen and (max-width: 576px) {
            padding-left: 15px;
          }
        `}
      >
        <div
          css={css`
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 8px;
            margin-left: 1.53rem;
          `}
        >
          Some of the Alternatives We Tested
        </div>
        <div
          css={css`
            font-size: 15px;
            ul {
              margin-bottom: 0;
            }
          `}
        >
          {this.props.children}
        </div>
      </div>
    )
  }
}

export {
  PlaybookCategory,
  PlaybookContext,
  PlaybookProduct,
  PlaybookAlternatives,
}
